import { render, staticRenderFns } from "./PenNameSaveDialog.vue?vue&type=template&id=5cc22ef8&scoped=true"
import script from "./PenNameSaveDialog.vue?vue&type=script&lang=ts"
export * from "./PenNameSaveDialog.vue?vue&type=script&lang=ts"
import style0 from "./PenNameSaveDialog.vue?vue&type=style&index=0&id=5cc22ef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc22ef8",
  null
  
)

export default component.exports